import { VendorEquipmentTypes } from './AppSettings';
import { ProgramType } from './ProgramTypes';

export interface EquipmentException {
  equipmentTypes: VendorEquipmentTypes[];
  grantedBy: string;
  grantedAt: string;
  note?: string;
}

/** Program types that allow equipment exceptions to be granted */
export const EquipmentExceptionAllowedProgramTypes: ProgramType[] = [
  ProgramType.solar,
  ProgramType.newHomes,
  ProgramType.newCommunity,
  ProgramType.doePr,
];
